export default __webpack_public_path__ + "static/media/a4size.043bfd80.jpg";